export default "/images/arrow-right.svg?f030f9db04711643a8b421bb60f13018";